import script from "./userStateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./userStateForm.vue?vue&type=script&setup=true&lang=js"

import "./userStateForm.vue?vue&type=style&index=0&id=08792274&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08792274"]])

export default __exports__